<template>
<div>
    <div class="md-layout">
        <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
            <stats-card header-color="rose">
                <template slot="header">
                    <div class="card-icon">
                        <i class="fas fa-money-check-alt"></i>
                    </div>
                    <h4 class="title">
                    COMPRAS DO MÊS
                    </h4>
                </template>

                <template slot="footer">
                    <div class="stats">
                        {{ homeRh.compras }}
                    </div>
                </template>
            </stats-card>
        </div>
        <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
            <stats-card header-color="green">
                <template slot="header">
                    <div class="card-icon">
                        <i class="fas fa-users"></i>
                    </div>
                    <h4 class="title">
                    QTDE DE FUNCIONÁRIOS
                    </h4>
                </template>

                <template slot="footer">
                    <div class="stats">
                        {{ homeRh.funcionarios }}
                    </div>
                </template>
            </stats-card>
        </div>
    </div>
</div>
</template>

<script>
import {
    StatsCard,
    AnimatedNumber
} from "@/components";
import Notify from '@/config/mixins/notify'

export default {
    components: {
        StatsCard
    },

    data() {
        return {
            homeRh: {}
        };
    },

    created() {
        this.getHomeRh();
    },

    mixins: [Notify],

    methods: {
        getHomeRh() {
            this.$http.get(this.$urlAPI + 'home/rh')
                .then(response => {
                    if(response.data.status){
                        this.homeRh = response.data.dados
                    } else{
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        }
    },
};
</script>
